import { QueryClientProvider } from '@tanstack/react-query'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useState, useEffect } from 'react'
import { UserSegmentationSurvey } from '~/features/marketing'
import { queryClient } from '~/providers/ReactQuery'
import { setWorkspacePreference } from '~/services/preferences/workspacePreferences'
import { useFeature } from '~/hooks/useFeature'

export const Route = createFileRoute('/workspaces/$workspaceId/onboarding')({
  component: OnboardingComponent,
})

function OnboardingComponent() {
  const { workspaceId } = Route.useParams()
  const navigate = useNavigate()
  const [isDone, setIsDone] = useState(false)
  const isOnboardingSurveyEnabled = useFeature('dashboard-onboarding-survey')

  // If feature flag is disabled, redirect to create-bot
  useEffect(() => {
    if (!isOnboardingSurveyEnabled) {
      navigate({ to: '/workspaces/$workspaceId/create-bot', params: { workspaceId }, replace: true })
    }
  }, [isOnboardingSurveyEnabled, navigate, workspaceId])

  const handleDone = async () => {
    // Wait for the preference to be saved before navigating
    await setWorkspacePreference({ path: 'onBoardingCompleted', value: true }, workspaceId)
    setIsDone(true)
    console.log('Onboarding completed, navigating to create-bot') // Debug log
    // Navigate to create-bot flow which will continue with bot questions
    navigate({ to: '/workspaces/$workspaceId/create-bot', params: { workspaceId } })
  }

  if (isDone) {
    return null
  }

  console.log('Rendering onboarding component') // Debug log
  return (
    <QueryClientProvider client={queryClient}>
      <UserSegmentationSurvey workspaceId={workspaceId} onDone={handleDone} />
    </QueryClientProvider>
  )
}
